import { render, staticRenderFns } from "./pm.vue?vue&type=template&id=48d93670&scoped=true"
import script from "./pm.vue?vue&type=script&lang=ts"
export * from "./pm.vue?vue&type=script&lang=ts"
import style0 from "./pm.vue?vue&type=style&index=0&id=48d93670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d93670",
  null
  
)

export default component.exports